







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CircleIcon, DiscIcon } from 'vue-feather-icons';

@Component({
  components: { CircleIcon, DiscIcon },
})
export default class FormProbability extends Vue {
  @Prop({ required: true, type: [Number], default: () => '' })
  readonly value!: number;

  @Prop({ required: false, type: Array })
  errors!: string[];

  currentValue = 0;

  mounted() {
    this.currentValue = this.value;
  }

  @Watch('value')
  watchValue() {
    this.currentValue = this.value;
  }

  onChange(value: number) {
    this.$emit('input', value);
  }

  get colorFull() {
    let clazzName = '';

    if (this.value >= 1 && this.value < 4) {
      clazzName = 'bad';
    } else if (this.value >= 4 && this.value < 7) {
      clazzName = 'okay';
    } else if (this.value >= 7) {
      clazzName = 'good';
    }
    return clazzName;
  }
}
